// extracted by mini-css-extract-plugin
export default {"item":"NewsItem_item__9bZVL","image":"NewsItem_image__KwchQ","chip":"NewsItem_chip__1SkeJ","title":"NewsItem_title__8-mZp"};